import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

function SignOutButton() {
  const navigate = useNavigate();
  const { signOut } = useAdminAuth();

  async function handleSignOut() {
    await signOut();
    navigate("/admin/books-portal/login");
  }

  return (
    <button
      type="button"
      onClick={handleSignOut}
      className="self-start rounded-md border border-zinc-300 px-3 py-1.5 text-sm font-medium text-zinc-700 hover:bg-zinc-100 sm:self-auto"
    >
      Sign out
    </button>
  );
}

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="flex flex-col gap-3 border-b border-zinc-200 bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <nav className="flex flex-wrap items-center gap-4 text-sm font-medium text-zinc-700">
          <Link to="/admin/books-portal" className="hover:text-zinc-950">
            Books
          </Link>
          <Link to="/admin/books-portal/leads" className="hover:text-zinc-950">
            Leads
          </Link>
          <Link to="/admin/books-portal/books/new" className="hover:text-zinc-950">
            + New Book
          </Link>
        </nav>
        <SignOutButton />
      </header>
      <main className="px-4 py-8 sm:px-8">
        <Outlet />
      </main>
    </div>
  );
}
